export default __webpack_public_path__ + "static/media/headset3.1d7c8311.jfif";